import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Markdown } from "@/components/Markdown";
import { ImageCarousel } from "@/components/ImageCarousel";
import { api } from "@/lib/api";

export default function EditorialeDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let ignore = false;
    setPost(null);
    setNotFound(false);
    api.get(`/posts/${slug}`)
      .then(({ data }) => { if (!ignore) setPost(data); })
      .catch(() => { if (!ignore) setNotFound(true); });
    return () => { ignore = true; };
  }, [slug]);

  if (notFound) {
    return (
      <div className="pt-44 pb-32 text-center">
        <p className="font-editorial text-2xl text-darkgrey">Articolo non trovato.</p>
        <button onClick={() => navigate("/editoriale")} className="mt-6 link-underline font-mono2 text-xs uppercase tracking-widest">← Torna all'editoriale</button>
      </div>
    );
  }
  if (!post) return <div className="min-h-screen flex items-center justify-center"><span className="font-mono2 text-xs uppercase text-darkgrey animate-pulse">Carico…</span></div>;

  return (
    <article data-testid="editoriale-detail-page" className="pt-32 md:pt-40 pb-24 md:pb-32">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <Link to="/editoriale" className="inline-flex items-center gap-2 font-mono2 text-xs uppercase tracking-widest text-darkgrey hover:text-ink mb-10">
          <ArrowLeft size={14} /> Editoriale
        </Link>
        <Reveal>
          <div className="flex items-center justify-between mb-6">
            <span className="font-mono2 text-[11px] uppercase tracking-widest text-darkgrey">{post.tag}</span>
            <span className="font-mono2 text-[11px] text-darkgrey">{post.date}</span>
          </div>
          <h1 className="font-heading text-4xl md:text-6xl leading-[1.02]">{post.title}</h1>
          {post.excerpt && <p className="font-editorial text-2xl text-darkgrey mt-6 leading-relaxed">{post.excerpt}</p>}
        </Reveal>

        {(() => {
          const gallery = (post.images && post.images.length ? post.images : (post.image ? [post.image] : [])).filter(Boolean);
          if (gallery.length === 0) return null;
          return (
            <Reveal delay={0.1}>
              <div className="mt-12">
                <ImageCarousel images={gallery} alt={post.title} />
              </div>
            </Reveal>
          );
        })()}

        {post.type === "articolo" && post.body && (
          <Reveal delay={0.1}>
            <div className="mt-12">
              <Markdown>{post.body}</Markdown>
            </div>
          </Reveal>
        )}

        <Reveal delay={0.15}>
          <div className="mt-16 pt-10 border-t border-darkgrey/30">
            <p className="font-mono2 text-xs uppercase tracking-widest text-darkgrey">2e Lab. Valentina Garavaglia</p>
            <Link to="/contatti" className="inline-block mt-6 border border-ink text-ink px-8 py-4 uppercase text-xs tracking-widest hover:bg-ink hover:text-greige transition-colors">
              Lavoriamo insieme
            </Link>
          </div>
        </Reveal>
      </div>
    </article>
  );
}
